module.exports = __webpack_public_path__ + "static/media/tetris.2cee06ee.png";